import { Loader, Tabs } from "@mantine/core";
import { withTranslation } from "react-i18next";
import COrporate from "./Corporate";
import Links from "./Links";
import Locations from "./Locations";
import ProfileInformation from "./ProfileInformation";
import profile from "../../assets/profile.png";
import location from "../../assets/Location.png";
import link from "../../assets/Link.png";
import corporate from "../../assets/corporate.png";
import Button from "../../components/Button";
import "./styles.css";
import Page from "../../components/Page";
import { useEffect, useState } from "react";
import { backendUrl } from "../../constants";
import { showNotification } from "@mantine/notifications";

const Index = () => {
  let createdBy = JSON.parse(localStorage.getItem("userData"));

  const [profileData, setProfileData] = useState({});
  const [coorporate, setCoorporate] = useState({});
  const [links, setLinks] = useState({ userId: createdBy.id, weblinks: [] });
  const [tab, setTab] = useState("1");
  const [defaultLinks, setDefaultLinks] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [refetch, setRefetch] = useState(false);

  //userInfo
  useEffect(() => {
    setIsLoading(true);
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}user/getCompanyDetails/${createdBy.id}`, options)
      .then((response) => response.json())
      .then((response) => {
        setProfileData({
          companyName: response.data[0]?.companyProfileInfo?.[0].companyName,
          companyLogo: response.data[0]?.companyProfileInfo?.[0].companyLogo,
          companyTagLine:
            response.data[0]?.companyProfileInfo?.[0].companyTagLine,
          companyIndustry:
            response.data[0]?.companyProfileInfo?.[0].companyTagLine,
          primaryFocus: response.data?.[0]?.companyAbout?.[0]?.primaryFocus,
          employees: response.data?.[0]?.companyAbout?.[0]?.employees?._id,
          founded: response.data?.[0]?.companyAbout?.[0]?.founded,
          companyType: response.data?.[0]?.companyAbout?.[0]?.companyType?._id,
          companyDescription:
            response.data?.[0]?.companyAbout?.[0]?.companyDescription,
          industries: response.data?.[0].companyIndustry.map(
            (obj) => obj.industry._id
          ),
        });
        //links
        response.data[0]?.companyWebLinks.map((obj) => {
          let aLink = { linkType: obj.linkType._id, linkURL: obj.linkURL };
          setLinks((a) => ({
            ...a,
            weblinks: [...a.weblinks, aLink],
          }));
          setDefaultLinks((v) => ({
            ...v,
            [obj.linkType.lookupName]: obj.linkURL,
          }));
        });

        //corporate
        setCoorporate({
          corporateCultureSummary:
            response.data[0]?.companyCoorporate[0]?.corporateCultureSummary,
          corporateCultureVideoLink:
            response.data[0]?.companyCoorporate[0]?.corporateCultureVideoLink,
          companyGallery:
            response.data[0]?.companyCoorporate[0]?.companyGallery,
          photoGalleryTitle:
            response.data[0]?.companyCoorporate[0]?.photoGalleryTitle,
        });
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  }, [createdBy.id, refetch]);

  //Save Company About
  const handleSaveData = () => {
    setIsLoading(true);
    if (tab === "1") {
      //about data
      const data = {
        companyDescription: profileData.companyDescription,
        primaryFocus: profileData.primaryFocus,
        companyType: profileData.companyType,
        employees: profileData.employees,
        founded: profileData.founded,
        userId: createdBy.id,
      };

      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify(data),
      };
      fetch(`${backendUrl}user/saveCompanyAbout`, options)
        .then((response) => response.json())
        .then((response) => {
          setIsLoading(false);
        })
        .catch((err) => console.error("erroe", err));

      //profile data

      let formData = new FormData();
      profileData.companyName &&
        formData.append("companyName", profileData.companyName);
      profileData.companyTagLine &&
        formData.append("companyTagLine", profileData.companyTagLine);
      profileData.companyLogo &&
        formData.append("companyLogo", profileData.companyLogo);
      profileData.industries &&
        formData.append("companyIndustry", profileData.industries);
      formData.append("userId", createdBy.id);
      const options2 = {
        method: "POST",
        headers: {
          Accept: "application/form-data",
        },
        body: formData,
      };
      fetch(`${backendUrl}user/saveCompanyProfileInfo`, options2)
        .then((response) => response.json())
        .then((response) => {
          setIsLoading(false);
        })
        .catch((err) => console.error(err));
    } else if (tab === "4") {
      let formData = new FormData();
      formData.append("userId", createdBy.id);
      Object.keys(coorporate).forEach((key) =>
        formData.append(key, coorporate[key])
      );
      const options2 = {
        method: "POST",
        headers: {
          Accept: "application/form-data",
        },
        body: formData,
      };
      fetch(`${backendUrl}user/saveCompanyCoorporate`, options2)
        .then((response) => response.json())
        .then((response) => {
          setIsLoading(false);
        })
        .catch((err) => console.error(err));
    } else if (tab === "5") {
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify(links),
      };
      fetch(`${backendUrl}user/saveCompanyWebLinks`, options)
        .then((response) => response.json())
        .then((response) => {
          setIsLoading(false);
        })
        .catch((err) => console.error(err));
    }
    showNotification({
      message: "Profile Information Saved Successfully",
      color: "green",
    });
  };

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <Tabs value={tab} onTabChange={setTab} variant="outline">
        <Tabs.List position="center" grow>
          <Tabs.Tab value="1" icon={<img src={profile} width="30px" />}>
            Profile Information
          </Tabs.Tab>
          <Tabs.Tab value="2" icon={<img src={location} width="30px" />}>
            Locations
          </Tabs.Tab>
          <Tabs.Tab value="4" icon={<img src={corporate} width="30px" />}>
            Corporate Culture
          </Tabs.Tab>
          <Tabs.Tab value="5" icon={<img src={link} width="30px" />}>
            Company Social Links
          </Tabs.Tab>
        </Tabs.List>
        {false ? (
          <div
            style={{
              width: "100vw",
              height: "50vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loader size="xl" color={"red"} />
          </div>
        ) : (
          <>
            <Tabs.Panel value="1" pt="xs">
              <ProfileInformation
                profileData={profileData}
                setProfileData={setProfileData}
              />
            </Tabs.Panel>
            <Tabs.Panel value="2" pt="xs">
              <Locations
                setRefetch={setRefetch}
                profileData={profileData}
                setProfileData={setProfileData}
              />
            </Tabs.Panel>
            <Tabs.Panel value="4" pt="xs">
              <COrporate
                coorporate={coorporate}
                setCoorporate={setCoorporate}
              />
            </Tabs.Panel>
            <Tabs.Panel value="5" pt="xs">
              <Links
                links={links}
                setLinks={setLinks}
                defaultLinks={defaultLinks}
              />
            </Tabs.Panel>
            <div className="pro-button">
              <Button
                title="Save Profile Settings"
                primary={true}
                width="300px"
                onClick={handleSaveData}
              />
            </div>
          </>
        )}
      </Tabs>
    </Page>
  );
};
export default withTranslation()(Index);
